// Public plan copy and USD prices from the dashboard repository:
// 10k.science/src/utility/billingPlans.js. Keep these in sync when plans change.
export const pricingPlans = [
  {
    id: "individual",
    name: "Individual",
    platform: "Web",
    description: "A world of science to explore on your own.",
    annualPrice: "$20",
    monthlyPrice: "$5",
    heading: "Explore the library",
    features: [
      "Full library of science experiences",
      "Explore in your browser on laptops and desktops",
    ],
  },
  {
    id: "classroom",
    name: "Classroom",
    platform: "Web",
    description: "Bring interactive science into your teaching.",
    annualPrice: "$200",
    heading: "Explore and teach",
    features: [
      "Full web content library",
      "Educator analytics",
      "Student join codes for the web",
      "Custom guide creation (beta)",
    ],
  },
  {
    id: "site",
    name: "Site license",
    platform: "Web + VR",
    description: "Bring web and VR to your entire site.",
    annualPrice: "$1,200",
    heading: "Teach across web + VR",
    features: [
      "Everything in Classroom",
      "Unlimited VR access across your site",
      "Student join codes for web and VR",
    ],
  },
];
